import { ImageModel } from './ImageModel';
import { LinkModel } from './LinkModel';

export enum ExpertType {
  Advisory = 'Advisory',
  Content = 'Content',
  Team = 'Team',
  Contributor = 'Contributor',
  Editor = 'Editor',
}

export type ExpertModel = {
  expertName: string;
  jobTitle: string;
  type: ExpertType;
  veryShortBio: string;
  shortBio: string;
  image?: ImageModel;
  landingPageLink?: LinkModel;
  socialMedia: {
    socialPlatform: string;
    link: LinkModel;
  }[];
};
